var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79px",
    height: "80px",
    viewBox: "0 0 79 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_carro copy 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kiosko",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav",
    transform: "translate(-683, -394)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_carro-copy-5",
    transform: "translate(683, 394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8480479,80 L13.1312701,80 C10.9267503,80 9.13757482,78.2081792 9.13757482,76.0004 L9.13757482,34.1805819 L2.26841892,41.0278972 L0,38.7561244 L38.3714243,0.455954405 C39.0104156,-0.151984802 40.000852,-0.151984802 40.6398432,0.455954405 L78.9473684,38.8841116 L76.6789495,41.1558844 L69.8417432,34.2765723 L69.8417432,76.0004 C69.8417432,78.2081792 68.0525677,80 65.8480479,80 Z M50.6720058,76.80032 L65.8480479,76.80032 C66.2953418,76.80032 66.6467869,76.4483552 66.6467869,76.0004 L66.6467869,31.0448955 L39.5216086,3.84761524 L12.332531,31.0128987 L12.332531,76.0004 C12.332531,76.4483552 12.6839762,76.80032 13.1312701,76.80032 L28.3073122,76.80032 L28.3073122,58.4021598 C28.3073122,56.1943806 30.0964877,54.4025597 32.3010075,54.4025597 L46.6783105,54.4025597 C48.8828303,54.4025597 50.6720058,56.1943806 50.6720058,58.4021598 L50.6720058,76.80032 Z M47.4770496,76.80032 L31.5022684,76.80032 L31.5022684,58.4021598 C31.5022684,57.9542046 31.8537136,57.6022398 32.3010075,57.6022398 L46.6783105,57.6022398 C47.1256044,57.6022398 47.4770496,57.9542046 47.4770496,58.4021598 L47.4770496,76.80032 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGray);
export default __webpack_public_path__ + "static/media/home-gray.a63e2b38d757162a8246e4b72234536d.svg";
export { ForwardRef as ReactComponent };